import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { addNoticeSave } from "@/api/managementCenter/notification";
import { remote } from "@/api/admin/dict";
import quillEditorCom from "@/components/common/quillEditor.vue";
import { sysFileUpload, sysFileDelete } from "@/api/managementCenter/otherApi";
import TreeSelect from "@/components/TreeSelect.vue";
import chargePerson from "@/components/management/reportManage/chargePerson.vue";
import { getDeptTree } from "@/api/managementCenter/otherApi";
export default {
  name: "notifyDialog",
  components: {
    quillEditorCom: quillEditorCom,
    chargePerson: chargePerson,
    TreeSelect: TreeSelect
  },
  props: [],
  data: function data() {
    var _this = this;

    var valiUserPass = function valiUserPass(rule, value, callback) {
      if ((value === "" || value.length == 0) && _this.form.type == 1) {
        callback(new Error("请选择人员"));
      } else {
        callback();
      }
    };

    var valiStrategyPass = function valiStrategyPass(rule, value, callback) {
      if ((value === "" || value.length == 0) && _this.form.type == 2) {
        callback(new Error("请选择通知部门策略"));
      } else {
        callback();
      }
    };

    var valiDeptPass = function valiDeptPass(rule, value, callback) {
      if ((value === "" || value.length == 0) && _this.form.type == 2) {
        callback(new Error("请选择部门"));
      } else {
        callback();
      }
    };

    return {
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < Date.now() - 86400000;
        }
      },
      typeList: [{
        name: "请选择",
        value: ""
      }, {
        name: "人员",
        value: "1"
      }, {
        name: "部门",
        value: "2"
      }, {
        name: "全校",
        value: "3"
      }],
      deptStrategyList: [{
        name: "请选择",
        value: ""
      }, {
        name: "本部门",
        value: "1"
      }, {
        name: "包含下级部门",
        value: "2"
      }],
      userText: "",
      userId: [],
      show: false,
      loading: false,
      personData: {
        userData: [],
        state: false,
        disabled: false,
        data: null
      },
      mapKey: {
        id: "id",
        // ID
        label: "name",
        // 显示名称
        children: "children" //子级字段名

      },
      departmentData: [],
      deptList: [],
      filelist: [],
      noticeTypeList: [],
      form: {
        name: "",
        overTime: "",
        content: "",
        type: "",
        launchDeptId: "",
        userList: [],
        noticeType: [],
        deptStrategy: "",
        deptList: [],
        attachIds: []
      },
      rules: {
        name: [{
          required: true,
          message: "请输入通知名称",
          trigger: "blur"
        }],
        overTime: [{
          required: true,
          message: "请选择通知时间",
          trigger: "change"
        }],
        noticeType: [{
          required: true,
          message: "请选择类型",
          trigger: "change"
        }],
        content: [{
          required: true,
          message: "请输入通知内容",
          trigger: "change"
        }],
        type: [{
          required: true,
          message: "请选择通知类型",
          trigger: "change"
        }],
        launchDeptId: [{
          required: true,
          message: "请选择发起部门",
          trigger: "change"
        }],
        userList: [{
          validator: valiUserPass,
          trigger: "change"
        }],
        deptStrategy: [{
          validator: valiStrategyPass,
          trigger: "change"
        }],
        deptList: [{
          validator: valiDeptPass,
          trigger: "change"
        }]
      }
    };
  },
  computed: {},
  methods: {
    beforeRemoveFn: function beforeRemoveFn(file) {
      var _this2 = this;

      if (!file.id) {
        return;
      }

      this.deleteFile(file.id, function () {
        _this2.filelist = _this2.filelist.filter(function (i) {
          return file.id != i.id;
        });
      });
    },
    deleteFile: function deleteFile(id, callback) {
      var _this3 = this;

      sysFileDelete(id).then(function (_ref) {
        var data = _ref.data;

        if (data.code == 0) {
          callback && callback();

          _this3.$message.success("删除成功!");
        } else {
          _this3.$message.warning(data.msg || "删除失败！");
        }
      }).catch(function (err) {
        _this3.$message.error("删除异常!");
      });
    },
    // 上传文件之前的方法
    beforeUploadFn: function beforeUploadFn(file) {
      var _this4 = this;

      var isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return isLt2M;
      }

      var fd = new FormData();
      fd.append("fromTarget", 0);
      fd.append("file", file); //上传到后台

      this.loading = true;
      sysFileUpload(fd).then(function (_ref2) {
        var data = _ref2.data;
        _this4.loading = false;

        if (data.code == 0) {
          _this4.$message.success("上传文件成功!");

          _this4.filelist.push(_objectSpread(_objectSpread({}, data.data), {}, {
            name: data.data.fileName
          }));
        } else {
          _this4.$message.warning(data.msg || "上传文件失败!");
        }
      }).catch(function (err) {
        _this4.loading = false;

        _this4.$message.error("上传文件异常!");
      });
    },
    //获取部门数据
    getDeptTreeData: function getDeptTreeData() {
      var _this5 = this;

      getDeptTree().then(function (_ref3) {
        var data = _ref3.data;

        if (data.code == 0) {
          if (data.data && data.data.length > 0) {
            if (data.data[0].id == 1) {
              _this5.departmentData = data.data[0].children;
            } else {
              _this5.departmentData = data.data;
            }
          }
        }
      }).catch(function (err) {});
    },
    //获取类型
    remoteFn: function remoteFn() {
      var _this6 = this;

      remote("notice_type").then(function (_ref4) {
        var data = _ref4.data;

        if (data.code == 0) {
          _this6.noticeTypeList = data.data || [];
        } else {
          _this6.$message.warning(data.msg || "获取类型失败!");
        }
      }).catch(function (err) {
        _this6.$message.error(data.msg || "获取类型异常!");
      });
    },
    // 显示弹框
    dialogShow: function dialogShow() {
      // 重置表单、显示弹框
      this.show = true;
      this.$nextTick(function () {
        this.$refs["ruleForm"].resetFields();
      });
    },
    addNoticeSaveFn: function addNoticeSaveFn() {
      var _this7 = this;

      this.form.attachIds = this.filelist.map(function (i) {
        return i.id;
      });
      this.loading = true;
      var params = JSON.parse(JSON.stringify(this.form));

      if (params.type == 1 || params.type == 3) {
        params.deptStrategy = "";
        params.deptList = [];
      }

      if (params.type == 2 || params.type == 3) {
        params.userList = [];
      }

      params.overTime += " 23:59:59";
      addNoticeSave(params).then(function (_ref5) {
        var data = _ref5.data;
        _this7.loading = false;

        if (data.code == 0) {
          _this7.$message.success("添加通知成功!");

          _this7.show = false;

          _this7.$emit("saveSuccess");
        } else {
          _this7.$message.warning(data.msg || "添加通知失败!");
        }
      }).catch(function (err) {
        _this7.loading = false;

        _this7.$message.error("服务器异常!");
      });
    },
    // 确定提交
    submitForm: function submitForm(formName) {
      var _this8 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this8.addNoticeSaveFn();
        } else {
          return false;
        }
      });
    },
    setDeptSingleMenu: function setDeptSingleMenu(key, data) {
      //获取子组件值
      this.form.launchDeptId = data.id;
    },
    setDeptDoubleMenu: function setDeptDoubleMenu(key, data) {
      //获取子组件值
      this.deptList = (data || []).map(function (item) {
        return item.id;
      });
    },
    //显示人员选择
    addUser: function addUser() {
      this.personData.state = true;
    },
    //选择人员
    closePerson: function closePerson(value) {
      if (!value.mans) {
        this.personData.state = false;
        return;
      }

      var mans = value.mans || [];
      this.userText = mans.map(function (item) {
        return item.name;
      }).join("、");
      this.userId = mans.map(function (item) {
        return item.userId;
      });
      this.personData.state = false;
    }
  },
  watch: {
    deptList: function deptList(val) {
      this.form.deptList = (val || []).map(function (i) {
        return {
          deptId: i
        };
      });
    },
    userId: function userId(val) {
      this.form.userList = (val || []).map(function (i) {
        return {
          userId: i
        };
      });
    },
    show: function show(value) {
      if (!value) {
        this.userText = "";
        this.userId = [];
        this.deptList = [];
        this.form = {
          name: "",
          content: "",
          type: "",
          launchDeptId: "",
          userList: [],
          deptStrategy: "",
          overTime: "",
          deptList: [],
          attachIds: [],
          noticeType: []
        };
      } else {
        this.getDeptTreeData();
        this.remoteFn();
      }
    }
  },
  filters: {}
};